// extracted by extract-css-chunks-webpack-plugin
module.exports = {"accordion":"_1FeOC0 aLs3Nr","headingWrapper":"-Tgfra"};